import React, {Component} from 'react';
import {Spinner} from "reactstrap";
import 'assets/sass/dashboard/deposits/withdraws/Accounts.scss';
import {app} from "app/app";
import {AddWallet} from "./AddWallet"
import {WalletRow} from "./WalletRow"
import { AppContext } from 'app/state/AppContext';

export class Wallets extends Component {
    static contextType = AppContext;

    renderOwnWallets() {
        if (this.ownWallets().length > 0) {
            return this.ownWallets().map(wallet => {
                return <WalletRow key={wallet.walletId()}
                                        isSelected={this.props.selectedWalletId === wallet.walletId()}
                                        handleAccountSelect={this.props.handleWithdrawAccountChange}
                                        handleDeleteWallet={this.props.handleDeleteWallet}
                                        data={wallet}/>
            });
        } else {
            return "No hay billeteras agendadas."
        }
    }

    ownWallets() {
        return this.props.walletBook.ownWalletsWithCurrency(this.props.currency)
    }

    renderButtons() {
        if (app.currentUser().canWithdrawCoin()) {
            return (
                <div className="footer-buttons">
                    <button className={"cta-button mr-2" + (this.props.canContinue ? '' : ' disabled')}
                            onClick={this.props.handleContinue}>
                        CONTINUAR RETIRO
                    </button>
                    <AddWallet
                        handleConfirmationTokenChange={this.props.handleConfirmationTokenChange}
                        {...this.props}
                    />
                </div>
            )
        } else {
            let verificationStateCode = app.currentUser().verificationState().code();
            let errorMessage = app.errorMessageMapper()[verificationStateCode]
            return <p> [ ! ] {errorMessage} </p>;
        }
    }

    getVerboseCurrency() {
        const { getCurrencyInstance } = this.context;
        return getCurrencyInstance(this.props.currency).asVerbose();
    }

    render() {
        if (this.props.loadingData) {
            return (
                <div className="spinner">
                    <Spinner className="spinner-color"/>
                </div>
            )
        } else {
            return (
                <div>
                    <p>Seleccioná la billetera a la que querés transferir tu saldo. Si es la primera vez, hacé click en
                        "Agregar billetera"</p>
                    <h6>Billeteras</h6>
                    {this.renderOwnWallets()}
                    <hr className="mb-4 mt-2"/>
                    {this.renderButtons()}
                </div>
            );
        }
    }
}
